// ILEARNProgressPage.jsx
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import DocumentDownload from '../../components/ILEARNProgress/DocumentsDownload';
import VideoBanner from '../../components/Videos/VideoBanner';
import ModuleProgress from '../../components/ILEARNProgress/ModuleProgress';
import { actions } from '../../util/actions';

const breakpoints = {
  tablet: 768,
  phone:  480,
};

const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  // padding: 20px;
  min-height: 75vh;
  width: 1100px;
  // max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: ${breakpoints.tablet}px) {
    padding: 16px;
  }

  @media (max-width: ${breakpoints.phone}px) {
    padding: 12px;
  }
`;

const ResourcesContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(240px, 25%) minmax(0, 75%);
  gap: 20px;
  width: 100%;
  align-items: flex-start;

  @media (max-width: ${breakpoints.tablet}px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  @media (max-width: ${breakpoints.phone}px) {
    gap: 12px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: ${breakpoints.phone}px) {
    display: none;
  }
`;

const VideoBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  @media (max-width: ${breakpoints.phone}px) {
    gap: 12px;
  }
`;

const ILEARNModulesButton = styled.button`
  font-family: 'Source Sans Pro', sans-serif !important;
  background-color: ${({ colors }) => colors.buttonBackground};
  color:            ${({ colors }) => colors.titleText};
  width:            100%;
  align-self:       stretch;
  border-radius:    45px;
  border:           none;
  padding:          16px 24px;
  font-size:        13px;
  font-weight:      bold;
  cursor:           pointer;
  display:          flex;
  flex-direction:   column;
  align-items:      center;
  gap:              4px;
  line-height:      1.2;
  text-align:       center;

  span:last-child {
    font-size: 0.8rem;
  }

  @media (max-width: ${breakpoints.phone}px) {
    width: 100%;
  }
`;

const BurgerButton = styled.button`
  display: none;

  @media (max-width: ${breakpoints.phone}px) {
    display: block;
    position: absolute;
    color: white;
    // top: ${({ more_top }) => (more_top ? '20%' : '9%')};
    margin-top:-206px
    left: 10px;
    background: none;
    border: none;
    font-size: 1.8rem;
    cursor: pointer;
    z-index: 20;
  }
`;

const Overlay = styled.div`
  display: none;

  @media (max-width: ${breakpoints.phone}px) {
    display: ${({ open }) => (open ? 'block' : 'none')};
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.4);
    z-index: 10;
  }
`;

const Sidebar = styled.div`
  display: none;

  @media (max-width: ${breakpoints.phone}px) {
    display: block;
    position: fixed;
    top: 0; left: 0;
    height: 100vh;
    width: 80%;
    max-width: 300px;
    background: white;
    box-shadow: 2px 0 8px rgba(0,0,0,0.2);
    transform: ${({ open }) =>
      open ? 'translateX(0)' : 'translateX(-100%)'};
    transition: transform 0.25s ease;
    z-index: 11;
    padding: 2rem 1rem;
    box-sizing: border-box;
  }
`;

const CloseButton = styled.button`
  display: none;

  @media (max-width: ${breakpoints.phone}px) {
    display: block;
    position: absolute;
    top: 12px;
    right: 12px;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
`;

const SidebarMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default function ILEARNProgressPage({ colors }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);
   const ISAFE_ROLES = new Set([
  "isafe_accountant",
  "isafe_moderator",
  "isafe_salesperson",
  "isafe_admin",
  "root",
]);
const SUBSCRIPTION_ROLES = new Set([
  "subscription_access",
  "subscription_accountant",
  "subscription_admin",
  "subscription_implementor",
  "subscription_salesperson",
]);
  const become = useSelector(state =>state.auth.become);
  const become_user = useSelector(state =>state.auth.become_user);
  const roles = useSelector(state => state.auth.user.roles);
  const roleIDs = new Set(roles?.map((r) => r.id));
  const hasSubscriptionAdminRole = Array.from(SUBSCRIPTION_ROLES).some((r) =>
        roleIDs.has(r)
      );
  const hasISAFEAdminRole = Array.from(ISAFE_ROLES).some((r) => roleIDs.has(r));

  const more_top = (become == 1 && hasISAFEAdminRole ) || ((become == 0 && hasSubscriptionAdminRole && !hasISAFEAdminRole ))

  useEffect(() => {
    dispatch({ type: actions.FETCH_ILEARN_CONTENT_ASYNC });
  }, [dispatch]);

  return (
    <DashboardContainer>
      {/* burger icon on mobile */}
      {menuOpen == false &&
      <BurgerButton more_top={more_top} onClick={() => setMenuOpen(true)}>☰</BurgerButton>
      }
      {/* overlay and sidebar */}
      <Overlay open={menuOpen} onClick={() => setMenuOpen(false)} />
      <Sidebar open={menuOpen}>
        <CloseButton onClick={() => setMenuOpen(false)}>×</CloseButton>
        <SidebarMenu>
          {/* <DocumentDownload colors={colors} /> */}
          <ILEARNModulesButton
            colors={colors}
            onClick={() => {
              navigate('/ilearn');
              setMenuOpen(false);
            }}
          >
            <span>ILEARN Modules</span>
            <span>Start Here</span>
          </ILEARNModulesButton>
        </SidebarMenu>
      </Sidebar>

      <ResourcesContainer>
        {/* inline on tablet+ */}
        <ContentContainer>
        {/* <DocumentDownload colors={colors} /> */}
        <ILEARNModulesButton
          colors={colors}
          onClick={() => navigate('/ilearn')}
        >
          <span>ILEARN Modules</span>
          <span>Start Here</span>
        </ILEARNModulesButton>
      </ContentContainer>

        {/* full-width video banner & module progress */}
        <VideoBannerContainer>
          <VideoBanner />
          <ModuleProgress colors={colors} />
        </VideoBannerContainer>
      </ResourcesContainer>
    </DashboardContainer>
  );
}
